<template>
  <v-menu ref="menu" transition="slide-y-transition" :close-on-content-click="false" origin="top" offset-y left>
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-badge color="red" :content="notificationLength" :value="notificationLength" overlap>
          <v-icon> mdi-bell </v-icon>
        </v-badge>
      </v-btn>
    </template>
    <v-list max-width="400px" dense>
      <v-list-item-group color="primary">
        <v-list-item
          v-for="(item, index) in warningItems"
          class="white pt-2"
          :key="'warning' + index"
          @click="clickItem(item)"
        >
          <v-list-item-content>
            <span class="black-text body-2">
              <v-icon color="yellow darken-2"> mdi-alert </v-icon>
              {{ item.message }}
              <v-divider />
            </span>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-for="(item, index) in infoItems"
          class="white pt-2"
          :key="'info' + index"
          @click="clickItem(item)"
        >
          <v-list-item-content>
            <span class="black-text body-2">
              <v-icon color="blue darken-2"> mdi-information </v-icon>
              {{ item.message }}
              <v-divider />
            </span>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-for="(item, index) in errorItems"
          class="white pt-2"
          :key="'error' + index"
          @click="clickItem(item)"
        >
          <v-list-item-content>
            <span class="black-text body-2">
              <v-icon color="red darken-2"> mdi-close-octagon </v-icon>
              {{ item.message }}
              <v-divider />
            </span>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import dayjs from 'dayjs'

import { SA_EXPIRATION_DATE } from '@/enum'

export default {
  name: 'Notification',

  mixins: [APIUtils, Message],

  data() {
    return {
      infoItems: [],
      warningItems: [],
      errorItems: [],
      timer: null,
      polling: false,
      interval: 10 * 1000,
    }
  },

  computed: {
    notificationLength: {
      get() {
        return this.infoItems.length + this.warningItems.length + this.errorItems.length
      },
    },
  },

  methods: {
    clickItem(item) {
      this.$router.push({ name: item.functionId, query: item.query }, () => {})
    },

    async startNotification(refreshFunction) {
      if (this.polling) {
        await refreshFunction()
        this.timer = setInterval(() => {
          // ブラウザのタブがアクティブの時のみ処理実施
          if (document.visibilityState === 'visible') {
            refreshFunction()
          }
        }, this.interval)
      }
    },
    stopNotification() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    async existsSaWf() {
      // ログインユーザーの処理待ちSA WFの存在チェック
      let result = false
      const params = {
        userCompanyCd: this.$store.getters.companyCd,
        nextCheckerCd: this.$store.getters.userCd,
      }
      const items = await API.get('/sa', params)

      if (items.length > 0) {
        result = true
      }

      return result
    },
    async existsSaExpiringSoon() {
      let result = false
      const params = {
        userCd: this.$store.getters.userCd,
        expirationDateFrom: dayjs().format('YYYY-MM-DD'),
        expirationDateTo: dayjs().add(SA_EXPIRATION_DATE, 'd').format('YYYY-MM-DD'),
      }
      result = await API.get('/sa/expiringSoon', params)
      return result
    },
    async existsMmmmWf() {
      // ログインユーザーの処理待ち4M WFの存在チェック
      let result = false
      const params = {
        userCompanyCd: this.$store.getters.companyCd,
        nextCheckerCd: this.$store.getters.userCd,
        issueDateFrom: dayjs().subtract(30, 'd').format('YYYY-MM-DD'),
        issueDateTo: dayjs().format('YYYY-MM-DD'),
      }
      const items = await API.get('/mmmm', params)

      if (items.length > 0) {
        result = true
      }

      return result
    },

    async refreshNotification() {
      // 通知更新
      let warningItems = []
      let infoItems = []
      let errorItems = []
      try {
        if (await this.existsSaWf()) {
          infoItems.push({
            message: this.$t('MSG0104'),
            functionId: 'T06',
            query: {},
          })
        }

        if (await this.existsSaExpiringSoon()) {
          warningItems.push({
            message: this.$t('MSG0136'),
            functionId: 'T06',
            query: { saExpiringSoon: 'true' },
          })
        }

        if (await this.existsMmmmWf()) {
          infoItems.push({
            message: this.$t('MSG0158'),
            functionId: 'T29',
            query: {},
          })
        }
      } catch (e) {
        this.stopNotification()
        errorItems.push({
          message: this.$t('MSG0149'),
          functionId: '',
          query: {},
        })
      } finally {
        this.infoItems = infoItems
        this.warningItems = warningItems
        this.errorItems = errorItems
      }
    },
  },

  created() {
    if (process.env.VUE_APP_NOTIFICATION_POLLING_INTERVAL) {
      this.polling = true
      this.interval = Number(process.env.VUE_APP_NOTIFICATION_POLLING_INTERVAL)
    }
  },
  mounted() {
    this.startNotification(this.refreshNotification)
  },
  beforeDestroy() {
    this.stopNotification()
  },
}
</script>
